import { render, staticRenderFns } from "./AIAssistanceButtonV2.vue?vue&type=template&id=603019c3&scoped=true&"
import script from "./AIAssistanceButtonV2.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceButtonV2.vue?vue&type=style&index=0&id=603019c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603019c3",
  null
  
)

export default component.exports